import { createFileRoute } from '@tanstack/react-router';

import { getSupportTicketsQueryOptions, SupportListLoading } from '@/_containers/support';
import { getCompanyQueryOptions } from '@/_pages/companies/api-service';

export const Route = createFileRoute('/_private/companies/_template/$id/support/')({
  loader: async (opts) => {
    const companyData = await opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id));
    opts.context.queryClient.ensureQueryData(
      getSupportTicketsQueryOptions({ companyId: companyData.data.freshdesk?.toString() || '' })
    );
  },
  staticData: {
    pageTitle: 'Support Tickets',
    tabKey: 'client/support',
    isFullWidth: true,
    isViewOnly: true,
  },
  pendingComponent: SupportListLoading,
});
